import React from "react";
import { Link, NavLink } from "react-router";

function Navbar() {
  return (
    <div>
      <header className="header-area header-sticky">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="main-nav">
                {/* ***** Logo Start ***** */}
                <NavLink to="/" className="logo">
                  <h1>Villa</h1>
                </NavLink>
                {/* ***** Logo End ***** */}
                {/* ***** Menu Start ***** */}
                <ul className="nav">
                  <li>
                    <NavLink to="/" >
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Properties">Properties</NavLink>
                  </li>
                  <li>
                    <NavLink to="/Property Details">Property Details</NavLink>
                  </li>
                  <li>
                    <NavLink to="/Contact Us">Contact Us</NavLink>
                  </li>
                  <li>
                    <NavLink to="/Products">Products</NavLink>
                  </li>
                  <li>
                    <NavLink to="/Shop">Shop</NavLink>
                  </li>
                  <li>
                    <Link to="/Cart">
                      <i className="fa fa-calendar" /> Cart
                    </Link>
                  </li>
                </ul>
                <a className="menu-trigger">
                  <span>Menu</span>
                </a>
                {/* ***** Menu End ***** */}
              </nav>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Navbar;
